import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=4bb3b84c&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3b84c",
  null
  
)

export default component.exports